// Researchpedia (Digital Library) base URL - used for SSO redirect from sidebar
export const RESEARCHPEDIA_BASE_URL =
  process.env.REACT_APP_RESEARCHPEDIA_URL || 'https://researchpedia.org';

const commonRoute = {
  researchProfile: '/member/global-research-profile/:id',
  globalPost: '/member/global-post/:postID',
  login: '/:type/login',
  changePassword: '/:type/change-password',
  newPassword: '/:type/new-password',
  myProfile: '/:type/my-details',
  myTask: '/:type/my-task',
  myTaskDetails: '/:type/my-task/detail/:id',
  forgotPassword: '/:type/forgot-password',
  resetPassword: '/:type/reset-password',
  signup: '/member/register',
  verifyEmail: '/member/verify-email',
  paymentPage: '/member/cc-avenue-payment',
  register: '/:type/member/register',
  registerDetails: '/:memberType/register/:userId/:formType',
  calendar: '/:memberType/calendar',
  myProfileType: '/:memberType/my-profile/:type',
  myProfileEvent: '/:memberType/my-profile/my-events/:eventId',
  publications: '/:memberType/publications/:publicationType',
  publicationAssistance: '/:memberType/publications/publicationAssistance',
  publicationSubmitPaperForm:
    '/:memberType/publications/:publicationType/submit-paper/:journalId',
  chaptersAndGroupsType: '/:memberType/chapters-groups/:type',
  chaptersDetailsType: '/:memberType/chapters-groups/chapters/:chapterId/:type',
  chaptersDetailsPeople:
    '/:memberType/chapters-groups/chapters/:chapterId/:type/:uId',
  groupDetails: '/:memberType/:moduleType/sig-groups/:groupId/:eventType',
  careerSupport: '/:memberType/career-support/:type',
  careerSupportView:
    '/:memberType/career-support/applied-career-support/:type/:careerId',
  careerSupportForm: '/:memberType/career-support/:careerId/:formType',
  careerEvents: '/:memberType/:careerType/:careerId/events',
  keynoteSpeakerView:
    '/:memberType/career-support/applied-career-support/keynote-speaker',
  keynoteSpeakerViewType:
    '/:memberType/career-support/applied-career-support/keynote-speaker/:pType',
  applicationDetailsView:
    '/:memberType/career-support/applied-career-support/keynote-speaker/speaker-applications/:id',
  viewInvitationDetails:
    '/:memberType/career-support/applied-career-support/keynote-speaker/invitation-received/:id',
  videoRecord:
    '/:memberType/career-support/applied-career-support/video-record',
  mentorship: '/:memberType/mentorship/mentee/:type',
  mentorshipMentor: '/:memberType/mentorship/mentor',
  mentorBookSession: '/:memberType/mentorship/mentee/book-session/:sId',
  cardInformation: '/:memberType/mentorship/mentee/cardInformation/:sId',
  singleMenteeDetails: '/:memberType/mentorship/mentor/details/:id',
  addNewSession: '/professional/mentorship/mentor/:formType',
  sessionDetail: '/professional/mentorship/mentor/session/details/:sId',
  mentorProfileDetail: '/:memberType/mentorship/mentor/profile/:id',

  nominateForAward: '/:memberType/nominate-for-award',
  nominateForAwardList: '/:memberType/nominate-for-award-list',
  certificatesAndRewards: '/:memberType/certificates-and-rewards',
  certificatesAndRewardsList: '/:memberType/certificates-and-rewards-list',
  awardWinners: '/:memberType/award-winners',
  helpSupport: '/:memberType/help/help-and-support',
  myPersonalExecutive: '/:memberType/help/my-personal-executive',
  inboxNotifications: '/:memberType/inbox-notifications/:type',
  inboxNotificationsChild: '/:memberType/inbox-notifications/:type/:cType',
  emailDetails: '/:memberType/inbox-notifications/:type/:emailId/:emailKey',
  emailForm: '/:memberType/inbox-notifications/:type/:emailId/upload-documents',
  networkManagementParent: '/:memberType/network-management/:type',
  networkManagement: '/:memberType/network-management/:type/:pType/:cType',
  createGroup: '/:memberType/network-management/:type/group/:groupId',
  digitalLibrary: '/:memberType/digital-library',
  profileManagement: '/:memberType/profile-management',
  profileDetail: '/:memberType/profile-management/profile-details/:userId/*',
  journalManagement: '/:memberType/journal-management',
  journalManagementType: '/:memberType/journal-management/:type',
  eventManagementType: '/:memberType/:moduleType/:type',
  eventDetailsType: '/:memberType/:moduleType/event-details/:eventId/:formType',
  eventauthorDetails: '/:memberType/:moduleType/event-details/:eventId/participants/author-details/:requestId',
  authorInfo: '/:memberType/author-details/:authorId',
  addEvent: '/:memberType/:moduleType/events/:eventId',
  tabEvent: '/:memberType/:requestType/:moduleType/events/:eventType/:eventId',
  //new route
  newEventRegistrationForm:
    '/:memberType/:moduleType/events/register/form/:eventId/:requestType/:requestId',
  viewNewEventRegistrationForm:
    '/:memberType/:moduleType/events/register/form/:eventId/:requestType/:requestId/view',
  viewNewEventAdOnServicesForm:
    '/:memberType/:moduleType/events/register/form/:eventId/:requestType/:requestId/services-view',
  eventAgandaForm:
    '/:memberType/:moduleType/event-details/:eventId/agenda/:agandaId',
  eventSessionDetails:
    '/:memberType/:moduleType/event-details/:eventId/session/:sessionId',
  eventPaper: '/:memberType/:moduleType/submitted-papers/:paperId',
  //create new route for new-submitted-abstract-flow
  newEventPaper: '/:memberType/:moduleType/new-submitted-papers/:paperId',
  //create new route for journal management
  journalPaper: '/:memberType/journal-management/submitted-papers/:paperId',
  activityPlan: '/:memberType/:moduleType/activity-plan/:planType/:planId',
  eventReviewerDetails: '/:memberType/event-management/reviewers/:reviewerId',
  journalReviewerDetails:
    '/:memberType/journal-management/reviewers/:reviewerId',
  conferencesAndEvents: '/:memberType/:moduleType/event-list/:eventType',
  conferencesAndEventsList:
    '/:memberType/:moduleType/:eventUserType/event-list/:eventType',
  abstractSubmissionForm:
    '/:memberType/:moduleType/:eventType/:eventId/abstract-submission/:abstractId',
  applyForCommitteeMember:
    '/:memberType/:moduleType/apply-for-committee-member',
  submittedAbstract: '/:memberType/:moduleType/submitted-abstract',
  sponsorshipnForm: '/:memberType/:moduleType/:eventType/:eventId/sponsorship',
  nominateForm: '/:memberType/:moduleType/:eventType/:eventId/nominate',
  upgradeUser: '/:memberType/upgrade',
  renewUser: '/:memberType/renew',
  certificateManagementType: '/:memberType/certificate-management/:type',
  certificateManagementEventDetail:
    '/:memberType/certificate-management/event-certificates/:eventID',
  speakerDetails: '/:memberType/:moduleType/speaker/:id',
  committeeMemberDetails: '/:memberType/:moduleType/committee-member/:id',
  postDetails: '/:memberType/:moduleType/network/post/post-details/:postID',
  userReasearchprofile: '/:memberType/user-profile/research-profile/:userID',
  emailRedirection: '/member/email-redirect',
  regionManagementType: '/:memberType/region-management/:rType',
  speakerInvitation: '/professional/member/speaker-invitation/register',
  campaignSignInWithOTP: '/member/campaign/register',
  unSubscribe: '/unsubscribe',
  //new
  newAbstractSubmissionTracking:
    '/:memberType/my-profile/my-events/:paperType/tracking/:eventId/:paperId',
  // accounts flow
  accountManagement: '/:userType/:moduleType',
  cvform: '/cvform',
  conferenceTicketDetails:
    '/:memberType/instant-ticket-generate/:eventId/:ticketType',
  conferenceTicketView:
    '/:memberType/instant-ticket-generate/:eventId/client-conference-tickets/:abstract_id/:action',
  otherConferencePassesView:
    '/:memberType/instant-ticket-generate/:eventId/other-conference-passes/:abstract_id/:action',
  passPayment: '/online-payment/:payment_type',
  requestReceivedType: '/:memberType/request-received/:type',
  raisedRequestType: '/:memberType/raised-request/:type',
  rbacRequestView: '/:memberType/:requestType/:type/:viewType/:request_id',
  participantsRequest:
    '/:memberType/:requestType/participants-event/request/:eventId',
  // certificateRequest:
  //   '/:memberType/:requestType/certificate-event/request/:eventId',
  participantsRequestView:
    '/:memberType/:requestType/participants-event/request/:eventId/view/:requestId',
  certificateRequestDetail:
    '/:memberType/:requestType/certificates-event/request/:eventId',
  trackingType: '/:memberType/tracking/:type',
  trackingCertificateEventUserList:
    '/:memberType/tracking/certificate-management/event-certificates/:eventID',
  trackingCertificateEventUserDetails:
    '/:memberType/tracking/certificate-management/event-certificates/:eventID/:logID',
  membershipTypeChangeDetails:
    '/:memberType/:requestType/membership-type-change/:requestId',
  completeProfile: '/:memberType/complete-profile',
  verifyEmail: '/:memberType/verify-email',
};

const superAdminRoute = {
  dashboard: '/super-admin/dashboard',
  userActivityManagement: '/super-admin/activity-management',
  userActivityManagementType: '/super-admin/activity-management/:type',
  profileManagement: '/super-admin/profile-management',
  eventManagement: '/super-admin/event-management',
  //new menu
  segmentManagement: '/super-admin/segment',
  segmentUsersList: '/super-admin/segment-users/:eID',
  segmentUserDetails: '/super-admin/segment-users/details/:id',
  journalManagement: '/super-admin/journal-management',
  chaptersAndGroups: '/super-admin/chapters-groups',
  chapters: '/super-admin/chapters-groups/chapters',
  addChapters: '/super-admin/chapters-groups/chapters/:chapterId',
  certificateManagement: '/super-admin/certificate-management',
  awardManagement: '/super-admin/award-management',
  awardManagementType: '/super-admin/award-management/:type',
  awardWinnerForm: '/super-admin/award-management/award-winners/:awardWinnerId',
  resourceManagement: '/super-admin/resource-management',
  resourceManagementForm:
    '/super-admin/resource-management/manage-resource/:resourceId',
  viewResource: '/super-admin/resource-management/:resourceId',
  careerManagement: '/super-admin/career-management',
  careerManagementType: '/super-admin/career-management/:type',
  careerManagementForm:
    '/super-admin/career-management/career-support/:careerId',
  careerEventMembers:
    '/super-admin/career-management/:careerId/events/:eventId',
  careerSupportView:
    '/super-admin/career-management/applied-career-support/:type/:careerId',
  KeynoteSpeaker: '/super-admin/career-management/6/keynote-speaker',
  KeynoteSpeakerType:
    '/super-admin/career-management/:uId/keynote-speaker/:type',
  sendInvitationDetails:
    '/super-admin/career-management/keynote-speaker/sent-invitation/:id',
  mentorshipManagement: '/super-admin/mentorship-management',
  mentorshipManagementType: '/super-admin/mentorship-management/:type',
  detailsOfMentor: '/super-admin/mentorship-management/details/:mId',
  detailsOfMentorType: '/super-admin/mentorship-management/details/:type',
  singleMenteeDetails:
    '/super-admin/mentorship-management/mentor/mentees/details/:id',
  mainMenteeDetail: '/super-admin/mentorship-management/mentees/details/:id',
  mentorSettlementDetails:
    '/super-admin/mentorship-management/payment/mentor-settlement/details/:id',
  menteeSettlementsDetails:
    '/super-admin/mentorship-management/payment/mentee-settlement/details/:id',

  viewMoeDetailsPayment:
    'super-admin/mentorship-management/payment/mentor-settlement/details/:sType/detail/:vId',
  brandingManagement: '/super-admin/branding-management',
  brand: '/super-admin/branding-management/:brandId',
  brandIndustry: '/super-admin/branding-management/:brandId/:industryId',
  inboxNotifications: '/super-admin/inbox-notifications',
  inboxNotificationsChild: '/super-admin/inbox-notifications/iferp',
  reports: '/super-admin/reports',
  reportsType: '/super-admin/reports/:type',
  reportsCountryWise: '/super-admin/reports/overall-report/:type',
  networkManagement: '/super-admin/network-management',
  universityManagement: '/super-admin/university-management',
  institutionManagement: '/super-admin/institution-management',
  regionManagement: '/super-admin/region-management',
  departmentManagement: '/super-admin/department-management',
  departmentManagementType: '/super-admin/department-management/:type',
  setting: '/super-admin/settings',
  newsLetter: '/super-admin/news-letter',
  paymentVerification: '/super-admin/payment-verification',
  paymentVerificationDetails: '/super-admin/payment-verification-details/:id',
  paymentVerificationDetailsEdit:
    '/super-admin/edit-payment-verification-details/:id',
  addAccount: '/super-admin/account-management/:formType',
  accountManagement: '/super-admin/account-management',
  accountManagementDetails:
    '/super-admin/account-management/details/:account_id',
  rbacUserRole: '/super-admin/settings/rbac/:type/:userType',
  rbacUserList: '/super-admin/settings/rbac/:type/:userType/:listType',
  rbacUserListDetails:
    '/super-admin/settings/rbac/:type/:userType/:listType/detail/:userId',
  instantTicketGenerate: '/super-admin/instant-ticket-generate',
  requestReceived: '/super-admin/request-received',
  tracking: '/super-admin/tracking',
  emailTemplates: '/super-admin/email-templates',
};

const adminRoute = {
  dashboard: '/admin/dashboard',
  userActivityManagement: '/admin/activity-management',
  userActivityManagementType: '/admin/activity-management/:type',
  profileManagement: '/admin/profile-management',
  eventManagement: '/admin/event-management',
  //new menu
  followUpAndDiscount: '/admin/follow-up-discount',
  followUpList: '/admin/follow-up-discount/:eID',
  manualfollowUpList: '/admin/follow-up-discount/:eID/manual-follow-up',
  followUpDetails:
    '/admin/follow-up-discount/:eID/manual-follow-up/:followupID/details',
  followUpUsers:
    '/admin/follow-up-discount/:eID/manual-follow-up/:followupID/followup-users',
  segmentManagement: '/admin/segment',
  segmentUsersList: '/admin/segment-users/:eID',
  segmentUserDetails: '/admin/segment-users/details/:id',
  journalManagement: '/admin/journal-management',
  chaptersAndGroups: '/admin/chapters-groups',
  chapters: '/admin/chapters-groups/chapters',
  addChapters: '/admin/chapters-groups/chapters/:chapterId',
  certificateManagement: '/admin/certificate-management',
  awardManagement: '/admin/award-management',
  awardManagementType: '/admin/award-management/:type',
  awardWinnerForm: '/admin/award-management/award-winners/:awardWinnerId',
  resourceManagement: '/admin/resource-management',
  resourceManagementForm:
    '/admin/resource-management/manage-resource/:resourceId',
  viewResource: '/admin/resource-management/:resourceId',
  careerManagement: '/admin/career-management',
  careerManagementType: '/admin/career-management/:type',
  careerManagementForm: '/admin/career-management/career-support/:careerId',
  careerEventMembers: '/admin/career-management/:careerId/events/:eventId',
  careerSupportView:
    '/admin/career-management/applied-career-support/:type/:careerId',
  KeynoteSpeaker: '/admin/career-management/6/keynote-speaker',
  KeynoteSpeakerType: '/admin/career-management/:uId/keynote-speaker/:type',
  sendInvitationDetails:
    '/admin/career-management/keynote-speaker/sent-invitation/:id',
  mentorshipManagement: '/admin/mentorship-management',
  mentorshipManagementType: '/admin/mentorship-management/:type',
  detailsOfMentor: '/admin/mentorship-management/details/:mId',
  detailsOfMentorType: '/admin/mentorship-management/details/:type',
  singleMenteeDetails:
    '/admin/mentorship-management/mentor/mentees/details/:id',
  mainMenteeDetail: '/admin/mentorship-management/mentees/details/:id',
  mentorSettlementDetails:
    '/admin/mentorship-management/payment/mentor-settlement/details/:id',
  menteeSettlementsDetails:
    '/admin/mentorship-management/payment/mentee-settlement/details/:id',

  viewMoeDetailsPayment:
    'admin/mentorship-management/payment/mentor-settlement/details/:sType/detail/:vId',
  brandingManagement: '/admin/branding-management',
  brand: '/admin/branding-management/:brandId',
  brandIndustry: '/admin/branding-management/:brandId/:industryId',
  inboxNotifications: '/admin/inbox-notifications',
  inboxNotificationsChild: '/admin/inbox-notifications/iferp',
  reports: '/admin/reports',
  reportsType: '/admin/reports/:type',
  reportsCountryWise: '/admin/reports/overall-report/:type',
  networkManagement: '/admin/network-management',
  universityManagement: '/admin/university-management',
  institutionManagement: '/admin/institution-management',
  regionManagement: '/admin/region-management',
  departmentManagement: '/admin/department-management',
  departmentManagementType: '/admin/department-management/:type',
  setting: '/admin/settings',
  newsLetter: '/admin/news-letter',
  paymentVerification: '/admin/payment-verification',
  paymentVerificationDetails: '/admin/payment-verification-details/:id',
  paymentVerificationDetailsEdit:
    '/admin/edit-payment-verification-details/:id',
  addAccount: '/admin/account-management/:formType',
  accountManagement: '/admin/account-management',
  accountManagementDetails: '/admin/account-management/details/:account_id',
  rbacUserRole: '/admin/settings/rbac/:type/:userType',
  rbacUserList: '/admin/settings/rbac/:type/:userType/:listType',
  rbacUserListDetails:
    '/admin/settings/rbac/:type/:userType/:listType/detail/:userId',
  instantTicketGenerate: '/admin/instant-ticket-generate',
  requestReceived: '/admin/request-received',
  raisedRequest: '/admin/raised-request',
  tracking: '/admin/tracking',
  emailTemplates: '/admin/email-templates',
};
const studentRoute = {
  dashboard: '/student/dashboard',
  calendar: '/student/calendar',
  liveEvents: '/student/dashboard/live-events',
  myProfile: '/student/my-profile',
  conferencesAndEvents: '/student/conferences-and-events',
  publications: '/student/publications',
  chaptersAndGroups: '/student/chapters-groups',
  careerSupport: '/student/career-support',
  mentorship: '/student/mentorship/mentee',
  mentorshipMentor: '/student/mentorship/mentor',
  mentorBookSession: '/student/mentorship/mentor/book-session',
  nominateForAward: '/student/nominate-for-award',
  certificatesAndRewards: '/student/certificates-and-rewards',
  awardWinners: '/student/award-winners',
  helpSupport: '/student/help/help-and-support',
  myPersonalExecutive: '/student/help/my-personal-executive',
  networkManagement: '/student/network-management/network',
  inboxNotifications: '/student/inbox-notifications',
  digitalLibrary: '/student/digital-library',
  cvform: '/student/cvform',
};
const profetionalRoute = {
  dashboard: '/professional/dashboard',
  liveEvents: '/professional/dashboard/live-events',
  myProfile: '/professional/my-profile',
  myTask: '/professional/my-task',
  myTaskDetails: '/professional/my-task/detail/:id',
  conferencesAndEvents: '/professional/conferences-and-events',
  publications: '/professional/publications',
  networkManagement: '/professional/network-management/network',
  inboxNotifications: '/professional/inbox-notifications',
  chaptersAndGroups: '/professional/chapters-groups',
  careerSupport: '/professional/career-support',
  mentorship: '/professional/mentorship/mentee',
  mentorshipMentor: '/professional/mentorship/mentor',
  mentorBookSession: '/professional/mentorship/mentor/book-session',
  nominateForAward: '/professional/nominate-for-award',
  certificatesAndRewards: '/professional/certificates-and-rewards',
  digitalLibrary: '/professional/digital-library',
  awardWinners: '/professional/award-winners',
  helpSupport: '/professional/help/help-and-support',
  chatWithMentee:
    '/professional/mentorship/mentee/my-submissions/chat/:id/:sId',
  chatWithMentor:
    '/professional/mentorship/mentor/my-submissions/chat/:id/:sId',
  cvform: '/professional/cvform',
};
const institutionalRoute = {
  dashboard: '/institutional/dashboard',
  myProfile: '/institutional/my-profile',
  conferencesAndEvents: '/institutional/conferences-and-events',
  publications: '/institutional/publications',
  activityPlan: '/institutional/activity-plan',
  activityPlanType: '/institutional/activity-plan/:type',
  institutionalEventForm:
    '/institutional/activity-plan/institutional-plan/add-event',
  institutionalEditEventForm:
    '/institutional/activity-plan/institutional-plan/edit-event/:eventId',
  ourAcademies: '/institutional/our-academicians',
  ourAcademiesType: '/institutional/our-academicians/:type',
  networkManagement: '/institutional/network-management/network',
  inboxNotifications: '/institutional/inbox-notifications',
  innovationAmbassadorType: '/institutional/innovation-ambassador/:type',
  innovationAmbassador: '/institutional/innovation-ambassador',
  chaptersAndGroups: '/institutional/chapters-groups',
  careerSupport: '/institutional/career-support',
  careerEventMembers: '/institutional/career-support/:careerId/events/:eventId',
  nominateForAward: '/institutional/nominate-for-award-list',
  certificatesAndRewardsList: '/institutional/certificates-and-rewards-list',
  collaboration: '/institutional/help/collaboration',
  eventCollaboration: '/institutional/help/collaboration/:eventType/:eventID',
  fundsAndGrants: '/institutional/help/funds-and-grants',
  fundsAndGrantsType: '/institutional/help/funds-and-grants/:type',
  helpSupport: '/institutional/help/help-and-support',
  liveEvents: '/institutional/dashboard/live-events',
};
const corporateRoute = {
  dashboard: '/corporate/dashboard',
  myProfile: '/corporate/my-profile',
  events: '/corporate/events',
  publications: '/corporate/publications',
  brandingAndPublicity: '/corporate/branding-and-publicity',
  brandingAndPublicityForm: '/corporate/branding-and-publicity/:type',
  networkManagement: '/corporate/network-management/network',
  inboxNotifications: '/corporate/inbox-notifications',
  chaptersAndGroups: '/corporate/chapters-groups',
  careerSupport: '/corporate/career-support',
  certificatesAndRewardsList: '/corporate/certificates-and-rewards-list',
  awardWinners: '/corporate/award-winners',
  nominateForAward: '/corporate/nominate-for-award-list',
  digitalLibrary: '/corporate/digital-library',
  helpSupport: '/corporate/help/help-and-support',
};
const resourceRoute = {
  dashboard: '/resource/dashboard',
  profileManagement: '/resource/profile-management',
  eventManagement: '/resource/event-management',
  //new menu
  segmentManagement: '/resource/segment',
  segmentUsersList: '/resource/segment-users/:eID',
  segmentUserDetails: '/resource/segment-users/details/:id',
  journalManagement: '/resource/journal-management',
  chaptersAndGroups: '/resource/chapters-groups',
  chapters: '/resource/chapters-groups/chapters',
  addChapters: '/resource/chapters-groups/chapters/:chapterId',
  networkManagement: '/resource/network-management',
  universityManagement: '/resource/university-management',
  institutionManagement: '/resource/institution-management',
  regionManagement: '/resource/region-management',
  departmentManagement: '/resource/department-management',
  departmentManagementType: '/resource/department-management/:type',
  setting: '/resource/settings',
  newsLetter: '/resource/news-letter',
  paymentVerification: '/resource/payment-verification',
  paymentVerificationDetails: '/admin/payment-verification-details/:id',
  paymentVerificationDetailsEdit:
    '/admin/edit-payment-verification-details/:id',
  inboxNotifications: '/resource/inbox-notifications',
  inboxNotificationsChild: '/resource/inbox-notifications/iferp',
  reports: '/resource/reports',
  reportsType: '/resource/reports/:type',
  reportsCountryWise: '/resource/reports/overall-report/:type',
  certificateManagement: '/resource/certificate-management',
  awardManagement: '/resource/award-management',
  awardManagementType: '/resource/award-management/:type',
  awardWinnerForm: '/resource/award-management/award-winners/:awardWinnerId',
  resourceManagement: '/resource/resource-management',
  resourceManagementForm:
    '/resource/resource-management/manage-resource/:resourceId',
  brandingManagement: '/resource/branding-management',
  brand: '/resource/branding-management/:brandId',
  brandIndustry: '/resource/branding-management/:brandId/:industryId',
  careerManagement: '/resource/career-management',
  careerManagementType: '/resource/career-management/:type',
  careerManagementForm: '/resource/career-management/career-support/:careerId',
  careerEventMembers: '/resource/career-management/:careerId/events/:eventId',
  careerSupportView:
    '/resource/career-management/applied-career-support/:type/:careerId',
  KeynoteSpeaker: '/resource/career-management/6/keynote-speaker',
  KeynoteSpeakerType: '/resource/career-management/:uId/keynote-speaker/:type',
  sendInvitationDetails:
    '/resource/career-management/keynote-speaker/sent-invitation/:id',
  mentorshipManagement: '/resource/mentorship-management',
  mentorshipManagementType: '/resource/mentorship-management/:type',
  detailsOfMentor: '/resource/mentorship-management/details/:uName',
  detailsOfMentorType: '/resource/mentorship-management/details/:type',
  singleMenteeDetails:
    '/resource/mentorship-management/mentor/mentees/details/:id',
  mainMenteeDetail: '/resource/mentorship-management/mentees/details/:id',
  mentorSettlementDetails:
    '/resource/mentorship-management/payment/mentor-settlement/details/:id',
  menteeSettlementsDetails:
    '/resource/mentorship-management/payment/mentee-settlement/details/:id',
  viewMoeDetailsPayment:
    'resource/mentorship-management/payment/mentor-settlement/details/:sType/detail/:vId',
  rbacUserRole: '/resource/settings/rbac/:type/:userType',
  rbacUserList: '/resource/settings/rbac/:type/:userType/:listType',
  rbacUserListDetails:
    '/resource/settings/rbac/:type/:userType/:listType/detail/:userId',
  instantTicketGenerate: '/resource/instant-ticket-generate',
  raisedRequest: '/resource/raised-request',
  tracking: '/resource/tracking',
};
//new role: accounts
const accountsRoute = {
  dashboard: '/accounts/dashboard',
  profileManagement: '/accounts/profile-management',
  eventManagement: '/accounts/event-management',
  segmentManagement: '/accounts/segment',
  segmentUsersList: '/accounts/segment-users/:eID',
  segmentUserDetails: '/accounts/segment-users/details/:id',
  journalManagement: '/accounts/journal-management',
  chaptersAndGroups: '/accounts/chapters-groups',
  chapters: '/accounts/chapters-groups/chapters',
  addChapters: '/accounts/chapters-groups/chapters/:chapterId',
  networkManagement: '/accounts/network-management',
  universityManagement: '/accounts/university-management',
  institutionManagement: '/accounts/institution-management',
  regionManagement: '/accounts/region-management',
  departmentManagement: '/accounts/department-management',
  departmentManagementType: '/accounts/department-management/:type',
  setting: '/accounts/settings',
  newsLetter: '/accounts/news-letter',
  // ------
  accountManagement: '/accounts/account-management',
  accountManagementDetails: '/accounts/account-management-details/:id',
  accountManagementDetailsEdit: '/accounts/edit-account-management-details/:id',
  paymentVerification: '/accounts/payment-verification',
  paymentVerificationDetails: '/accounts/payment-verification-details/:id',
  paymentVerificationDetailsEdit:
    '/accounts/edit-payment-verification-details/:id',

  inboxNotifications: '/accounts/inbox-notifications',
  reports: '/accounts/reports',
  reportsType: '/accounts/reports/:type',
  reportsCountryWise: '/accounts/reports/overall-report/:type',
  certificateManagement: '/accounts/certificate-management',
  awardManagement: '/accounts/award-management',
  awardManagementType: '/accounts/award-management/:type',
  awardWinnerForm: '/accounts/award-management/award-winners/:awardWinnerId',
  resourceManagement: '/accounts/resource-management',
  resourceManagementForm:
    '/accounts/resource-management/manage-resource/:resourceId',
  brandingManagement: '/accounts/branding-management',
  brand: '/accounts/branding-management/:brandId',
  brandIndustry: '/accounts/branding-management/:brandId/:industryId',
  careerManagement: '/accounts/career-management',
  careerManagementType: '/accounts/career-management/:type',
  careerManagementForm: '/accounts/career-management/career-support/:careerId',
  careerEventMembers: '/accounts/career-management/:careerId/events/:eventId',
  careerSupportView:
    '/accounts/career-management/applied-career-support/:type/:careerId',
  KeynoteSpeaker: '/accounts/career-management/6/keynote-speaker',
  KeynoteSpeakerType: '/accounts/career-management/:uId/keynote-speaker/:type',
  sendInvitationDetails:
    '/accounts/career-management/keynote-speaker/sent-invitation/:id',
  mentorshipManagement: '/accounts/mentorship-management',
  mentorshipManagementType: '/accounts/mentorship-management/:type',
  detailsOfMentor: '/accounts/mentorship-management/details/:uName',
  detailsOfMentorType: '/accounts/mentorship-management/details/:type',
  singleMenteeDetails:
    '/accounts/mentorship-management/mentor/mentees/details/:id',
  mainMenteeDetail: '/accounts/mentorship-management/mentees/details/:id',
  mentorSettlementDetails:
    '/accounts/mentorship-management/payment/mentor-settlement/details/:id',
  menteeSettlementsDetails:
    '/accounts/mentorship-management/payment/mentee-settlement/details/:id',
  viewMoeDetailsPayment:
    'accounts/mentorship-management/payment/mentor-settlement/details/:sType/detail/:vId',
  rbacUserRole: '/accounts/settings/rbac/:type/:userType',
  rbacUserList: '/accounts/settings/rbac/:type/:userType/:listType',
  rbacUserListDetails:
    '/accounts/settings/rbac/:type/:userType/:listType/detail/:userId',
};

export {
  superAdminRoute,
  adminRoute,
  commonRoute,
  studentRoute,
  profetionalRoute,
  institutionalRoute,
  corporateRoute,
  resourceRoute,
  accountsRoute,
};
